@if (isInitialized) {
<oe-navigation-view [title]="this.component.alias" [component]="component" [formGroup]="formGroup">
    <ion-grid class="ion-no-padding">
      <ion-row class="ion-justify-content-center ion-align-items-center ion-padding">
        <ion-col size-md="4" size-xs="9">
          <oe-img [img]="img"></oe-img>
        </ion-col>
        @if (!imgDidLoad) {
          <ion-col size-md="4" size-xs="9">
            <oe-modal-line [name]="'EVSE_SINGLE.HOME.MODE.LABEL' | translate" [converter]="CONVERT_TO_MODE_LABEL"
              [channelAddress]="component.id + '/_PropertyMode'">
            </oe-modal-line>
            <oe-modal-line [name]="'EVSE_SINGLE.HOME.ACTUAL_MODE.LABEL' | translate"
              [converter]="CONVERT_TO_ACTUAL_MODE_LABEL" [channelAddress]="component.id + '/ActualMode'">
            </oe-modal-line>
            <oe-modal-line [name]="'EVSE_SINGLE.HOME.STATE_MACHINE.LABEL' | translate"
              [converter]="CONVERT_TO_STATE_MACHINE_LABEL" [channelAddress]="component.id + '/StateMachine'">
            </oe-modal-line>
            @if (chargePointComponent) {
              <oe-modal-line [name]="'EVSE_SINGLE.HOME.POWER' | translate" [converter]="Converter.POWER_IN_WATT"
                [channelAddress]="chargePointComponent.id + '/ActivePower'">
              </oe-modal-line>
            }
            <oe-modal-line [name]="'EVSE_SINGLE.HOME.ENERGY_SINCE_START' | translate"
              [converter]="Converter.TO_WATT_HOURS" [channelAddress]="component.id + '/SessionEnergy'">
            </oe-modal-line>
          </ion-col>
        }
      </ion-row>
    </ion-grid>
    <oe-components-scheduler-one-tasks [(payload)]="payload"></oe-components-scheduler-one-tasks>
</oe-navigation-view>
}
